module.exports = __webpack_public_path__ + "img/bobsled3.788efd65.jpg";